import { Radio, RadioProps } from "@mui/material";
import CheckedIcon from "../../icons/CheckedIcon";
import UncheckedIcon from "../../icons/UncheckedIcon";

interface RadioButtonProps extends RadioProps {
  variant?: "default" | "blank";
}

function RadioButton({ variant = "default", ...props }: RadioButtonProps) {
  if (variant === "blank") {
    return <Radio {...props} />;
  }

  return (
    <Radio checkedIcon={<CheckedIcon />} icon={<UncheckedIcon />} {...props} />
  );
}

export default RadioButton;
